<div class="center-content fade-in-animation">
  <div class="report-title">Métricas até o período: {{grownMetricsRows[0]?.date | date:'MM/yy' : 'UTC'}}</div>

  <div class="report-cards-row">
    <report-card [title]="'Visualizações'" [value]="(grownMetricsRows[0]?.view_total | number: '1.0-3') || '-'" [description]="'Descrição aqui'" [icon]="'eye'" [iconType]="'feather-icons'"></report-card>
    <report-card [title]="'Cupons Gerados'" [value]="(grownMetricsRows[0]?.coupons | number: '1.0-3') || '-'" [description]="'Descrição aqui'" [icon]="'ticket'"></report-card>
    <report-card [title]="'Cupons Lançados'" [value]="(grownMetricsRows[0]?.launched_coupons | number: '1.0-3') || '-'" [description]="'Descrição aqui'" [icon]="'ticket'"></report-card>
    <report-card [title]="'Receita Lançada'" [value]="grownMetricsRows[0]?.revenue_released_formated || '-'" [description]="'Descrição aqui'" [icon]="'usd'"></report-card>
    <report-card [title]="'Receita Potencial'" [value]="grownMetricsRows[0]?.potential_economy_formated || '-'" [description]="'Descrição aqui'" [icon]="'usd'"></report-card>
    <report-card [title]="'Total de descontos'" [value]="grownMetricsRows[0]?.potential_revenue_formated || '-'" [description]="'Descrição aqui'" [icon]="'usd'"></report-card>
  </div>

  <div class="card">
    <div class="card-content">

      <div class="card-header">
        <h4 class="no-margin">Métricas de crescimento</h4>
        <info-tooltip [description]="'Descrição'"></info-tooltip>
      </div>

      <div class="chart-container">
        <canvas id="canvas" width="990" height="275" *ngIf="grownMetricsRows.length"></canvas>
      </div>

      <ngx-datatable
        class="report-table"
        [headerHeight]="'auto'"
        [rowHeight]="28"
        [columnMode]="columnModes.flex"
        [rows]="grownMetricsRows"
        [columns]="grownMetricsColumns">
      </ngx-datatable>

    </div>
  </div>

  <div class="warning-box">
    <img src="assets/shared/img/warning_box.png" alt="Warning">
    <div>
      <p>De acordo com sua proposta, seu <b>ticket médio é de {{ (transformCurrency(activeAccount?.offer?.purchase_value)) || 'R$ 0' }}</b> e <b>desconto médio de {{ (transformCurrency(activeAccount?.offer?.purchase_economy)) || 'R$ 0' }}</b>.</p>
      <small>Se deseja atualizar essas informações, por favor, envie um e-mail para <a target="_blank" href="mailto:suporte@allya.com.br">suporte@allya.com.br</a> com os valores atualizados.</small>
    </div>
  </div>

  <div class="card">
    <div class="card-content">

      <div class="card-header">
        <h4 class="no-margin">Top 10 Empresas</h4>
        <info-tooltip [description]="'Descrição'"></info-tooltip>
      </div>

      <ngx-datatable
        class="auxiliary-table companies-table"
        [headerHeight]="'auto'"
        [rowHeight]="35"
        [columnMode]="columnModes.flex"
        [rows]="topCompaniesRows"
        [columns]="topCompaniesColumns">
      </ngx-datatable>

    </div>
  </div>
</div>
